module.exports = __webpack_public_path__ + "img/memory-storage-animate.e211f8db.svg";